// 雪季工具函式：統一雪季日期邏輯（12月 ~ 隔年4月）
// 規則：5月起算下一個雪季（今年12月~明年4月），12月與1~4月則屬於當前雪季

export function toDateString(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// 回傳目前所屬（或即將到來）雪季的起訖日（Date 物件，當天 00:00:00）
export function getSeasonBounds() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const month = today.getMonth() + 1; // 1-12
  const year  = today.getFullYear();

  let seasonStart, seasonEnd;
  if (month >= 5) {
    // 5月~12月：本季為今年12月~明年4月
    seasonStart = new Date(year, 11, 1);
    seasonEnd   = new Date(year + 1, 3, 30);
  } else {
    // 1月~4月：本季為去年12月~今年4月
    seasonStart = new Date(year - 1, 11, 1);
    seasonEnd   = new Date(year, 3, 30);
  }
  return { seasonStart, seasonEnd, today };
}

// 回傳可預約日期字串陣列（從明天起，至雪季結束為止）
export function getSeasonDates() {
  const { seasonStart, seasonEnd, today } = getSeasonBounds();
  const start = today > seasonStart ? today : seasonStart;
  const from = new Date(start);
  from.setDate(from.getDate() + 1); // 從明天開始

  const dates = [];
  for (let d = new Date(from); d <= seasonEnd; d.setDate(d.getDate() + 1)) {
    dates.push(toDateString(new Date(d)));
  }
  return dates;
}

// 回傳 <input type="date"> 用的 min/max 字串（含今天，給請假/排班用）
export function getSeasonRange() {
  const { seasonStart, seasonEnd, today } = getSeasonBounds();
  const min = today > seasonStart ? today : seasonStart;
  return { min: toDateString(min), max: toDateString(seasonEnd) };
}